import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useTestId } from "@/hooks";
import { AdFooter } from "../Sections/AdFooter";
export const BottomSection = () => {
    const testId = useTestId("BottomSection");
    return (_jsx(Box, { gridColumn: {
            "breakpoint.base": "col-start / span 4",
            "breakpoint.sm": "col-start / span 8",
            "breakpoint.lg": "col-start / span 4",
            "breakpoint.xl": "col-start 2 / span 6",
            "breakpoint.xxxl": "col-start 3 / span 5",
        }, marginTop: "spacing.16", testId: testId, unsafe_className: "HideOnPrint", height: "min-content", paddingBottom: "spacing.30", children: _jsx(AdFooter, {}) }));
};
